import * as React from 'react';
import { Link } from 'gatsby';
import Social from './social';
import Menu from './menu';
import OfficeMenu from './menu/office-menu';
import tech from './technology';
import extraOffices from './additional-address.json';
// styles
import cx from 'classnames';
import styles from './footer.module.css';

const Routes = require('../../routes').Routes;

const MENU = [
  {
    title: 'About us',
    to: '/about-us/',
  },
  {
    title: 'Cases',
    to: Routes.CASE_STUDIES,
  },
  {
    title: 'Services',
    to: Routes.SERVICES_MVP_DEVELOPMENT,
  },
  {
    title: 'Partnership',
    to: Routes.PARTNERSHIP,
  },
  {
    title: 'Blog',
    to: Routes.BLOG,
  },
];

function MenuItem(e: { title: string; to: string }) {
  return (
    <Link to={e.to} className={styles.link} itemProp="url">
      {e.title}
    </Link>
  );
}

function Footer() {
  const fullYear = new Date().getFullYear();

  return (
    <footer className={styles.container} itemScope itemType="http://schema.org/WPFooter">
      <div className="inner">
        <div className={styles.top}>
          <div className={styles.column}>
            <Menu title="Menu" list={MENU} getItem={MenuItem} />
          </div>
          <div className={styles.column}>
            <Menu title="Technologies" list={tech} getItem={MenuItem} />
          </div>
          <div className={cx(styles.column, styles.officeList)}>
            <OfficeMenu extraOffices={extraOffices} />
          </div>
          <div className={styles.column} itemScope itemType="http://schema.org/Organization">
            <h4 className={styles.title}>Say hello</h4>
            <div className={styles.address}>
              <a href="mailto:talk@brocoders.team" className={styles.mainLink} itemProp="email">
                talk@brocoders.team
              </a>
            </div>
            <div className={styles.item}>
              <a href="tel:+380665773446" className={styles.link} itemProp="telephone">
                +38 050 768 76 91
              </a>
              <br />
              <a href="tel:+13473891261" className={styles.link} itemProp="telephone">
                +1 347 389 12 61
              </a>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <span className={styles.copy}> © 2011-{fullYear} Brocoders.com </span>
          <div className={styles.privacy}>
            <Link className={styles.link} to="/terms-of-use">
              Terms & Conditions
            </Link>
            <Link className={styles.link} to="/privacy-policy">
              Privacy Policy
            </Link>
          </div>
          <Social />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
